var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "serviceAgreement" }, [
    _vm.showTitle
      ? _c("div", { staticClass: "serviceAgreementTitle" }, [
          _vm._v("\n    亦邦物流运输条款与条件\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _vm._m(3),
    _vm._v(" "),
    _vm._m(4),
    _vm._v(" "),
    _vm._m(5),
    _vm._v(" "),
    _c("div", { staticClass: "paragraph" }, [
      _c("div", [_vm._v("五、货物发运信息确认，相应运费、关税和费用")]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v(
            "\n        为保证货物及时准确的发运，亦邦物流会将所有货物发运信息提供给您进行确认，海运整柜货物不迟于船司截单前6小时提供，海运散货及空运货物不迟于装货发运前6小时提供，提供方式包括但不限于通过电话、微信、微信群等方式，若您对亦邦物流提供的货物发运信息有异议的，请在收到亦邦物流提供的货物发运信息后5个小时内予以反馈，逾期未提出则视为无异议，亦邦物流将正常发运。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        亦邦物流的运费将按照每件货物实际重量计算标准和体积重量计算标准两者中较高的计算，亦邦物流可以对任何一件货物重新称重和测量以确认其计算数据，并以此作为向您收取运费的依据。为免疑义：\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        亦邦物流的实际重量计算标准如下：货物重量以毛重计算（含商品销售包装的重量）；超出重量向上取整，例：如超出重量2.54kg，按3kg计算续重运费。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("体积重量计算标准如下：")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table_standard" },
          _vm._l(_vm.tableData, function(item, index) {
            return _c(
              "div",
              { key: index, staticClass: "table_standard_item" },
              [
                _c(
                  "div",
                  {
                    staticClass: "table_item_left",
                    staticStyle: { "font-size": "14px" }
                  },
                  [
                    _vm._v(
                      "\n            " + _vm._s(item.name) + "\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "table_item_right" }, [
                  _vm._v(_vm._s(item.value))
                ])
              ]
            )
          }),
          0
        )
      ])
    ]),
    _vm._v(" "),
    _vm._m(6),
    _vm._v(" "),
    _vm._m(7),
    _vm._v(" "),
    _vm._m(8),
    _vm._v(" "),
    _vm._m(9),
    _vm._v(" "),
    _vm._m(10),
    _vm._v(" "),
    _vm._m(11),
    _vm._v(" "),
    _vm._m(12),
    _vm._v(" "),
    _vm._m(13),
    _vm._v(" "),
    _vm._m(14),
    _vm._v(" "),
    _vm._m(15),
    _vm._v(" "),
    _vm._m(16),
    _vm._v(" "),
    _vm._m(17),
    _vm._v(" "),
    _vm._m(18),
    _vm._v(" "),
    _vm._m(19)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "paragraph",
        staticStyle: { "font-weight": "bold", color: "#303133" }
      },
      [
        _c("div", [_vm._v("重要提示")]),
        _vm._v(" "),
        _c("div", [
          _c("p", [
            _vm._v(
              "\n        当您(以下也称为“发件人”)委托我公司亦邦（深圳）国际物流有限公司(以下简称“亦邦物流”）从事货物运输服务时，您即代表您自身或货物的收件人（“收件人”）或与运单中所称的货物具有利益关系的任何其他方同意适用本条款与条件。\n      "
            )
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "paragraph",
        staticStyle: { "font-weight": "bold", color: "#303133" }
      },
      [
        _c("div"),
        _vm._v(" "),
        _c("div", [
          _c("p", [
            _vm._v(
              "\n        本条款与条件所称货物，是指一份运单下所有的文件、包裹或长宽高不超过【12m】*【3m】*【3m】的物品，亦邦物流将根据您的要求选择空运、陆运或任何其他方式进行该货物的运输。一份运单应包括亦邦物流或发件人电子商务工具所出具的任何货物标识或文件，例如标签、条形码、运单或交货单，及其电子数据形式。每一货物运输都将适用本条款与条件中关于责任限制的规定。如发件人要求更大程度的保护，可另行投保（有关细节请参看下文）。\n      "
            )
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "paragraph" }, [
      _c("div", [_vm._v("一、清关及遵从监管")]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v("亦邦物流为提供服务可以代表发件人或收件人从事以下事项：")
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        （1）填写各类文件，更正产品或服务项目的编码，并按照有关法律法规的要求预付关税、税金或其他监管费用（以下简称“关税”）；\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        （2）作为发件人或收件人真实合法的代理人或指定某一报关代理办理进出口管制的有关手续和清关；\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        （3）应他人要求将承运的货物转交给收件人的报关代理，或运到其它地点，只要亦邦物流有合理理由判断该他人已获得必要授权。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        发件人或收件人将提供任何适用法律要求的额外授权，以便亦邦物流清关。\n      "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "paragraph" }, [
      _c("div", [_vm._v("二、不能承运的货物")]),
      _vm._v(" "),
      _c("div", [
        _c("p", [_vm._v("有下列情形之一的货物将不予运输：")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        （1）货物中包含完整的武器、弹药、爆炸物、爆炸装置或试验装置、气枪、复制或仿制武器；仿冒品；现金；任何贵金属条；活体动物、禁运的动物器官或遗骸，如象牙；人类遗骸或骨灰；宝石裸石或半宝石；大麻或其衍生物；或者非法物品，如毒品或者其他违禁药物；\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        （2）货物属于《关于危险货物公路运输的欧洲协定》（“ADR”）、国际航空运输协会（“IATA”）、国际民用航空组织（“ICAO”）、或其他有关组织所规定的有害物品、危险物品，以及属于禁运或限运的物品（以下简称“危险物品”）；\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("（3）货物属于收件地国所规定的违禁物品；")]),
        _vm._v(" "),
        _c("p", [
          _vm._v("（4）货物中包含亦邦物流无法安全或合法运输的任何其他物品；")
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        （5）地址不正确、或表示不恰当，或包装有缺陷或不充足、不能保证在一般注意程度下的安全运输；\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        （6）发件人、收件人或与货物具有直接或间接利益关系的任何其他方在任何适用制裁名单上被列为被拒绝方或受限制方。\n      "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "paragraph" }, [
      _c("div", [_vm._v("三、派送和不能派送")]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v(
            "\n        货物不能派送到某邮政信箱或仅按邮政编码派送。货物将按发件人提供的收件人地址派送，但不一定直接送达收件人本人，经发件人或收件人允许的代收人签收或收件人认可的其他方式签收，视为送达。如果收件人地址设有集中接收点，货物将被派送到该接收点。若发件人与收件人提供的收件地址不一致的，则以收件人提供的地址为准。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        当货物即将派送或未能成功派送时，亦邦物流可以通知收件人、并向收件人提供以下可供选择的派送方式，如指定其他日期派送，不需要签名的派送，改址或在亦邦物流服务点自提。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        收件人或您/收件人允许的代收人对货物进行签收即表明您确认亦邦物流已经按照本条款与条件履行完毕合同义务。您签收后再向亦邦物流提出理赔的，亦邦物流有权不予受理。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        有以下情形之一的，亦邦物流将以合理的努力将货物退还发件人，因此发生的费用由发件人支付：该货物被认为是本条款与条件第二条不能承运的货物；海关认为发件人低报了货物的价值；无法合理确定或找到收件人（包括但不限于提供的地址不详、提供的联系方式联系不上；收件人拒绝接收货物或支付关税或快递费。如不能退还，亦邦物流可以对货物进行放弃、处置或变卖，且不就上述行为向发件人或其他人承担任何责任。若法律或执法机关禁止亦邦物流将货物的全部或部分退还发件人或货物属于危险物品，则亦邦物流有权销毁货物，由此产生的费用由发件人承担。\n      "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "paragraph" }, [
      _c("div", [_vm._v("四、查验")]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v(
            "\n        出于安全或海关或其他监管机关的要求，亦邦物流有权在未通知的情况下对货物进行开封查验。\n      "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "paragraph" }, [
      _c("div"),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v(
            "\n        如您对亦邦物流的实际重量及/或体积重量的结果有异议，请您在收到称重结果后24小时内及时联系客服沟通核实，经核实确认因货物重量误差导致您多支付运费的，多支付运费将退还给您，逾期提出的，亦邦物流有权不予受理。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticStyle: { display: "inline-block" } }, [
          _vm._v("\n        亦邦物流的收费标准如下："),
          _c(
            "span",
            { staticStyle: { "font-weight": "bold", color: "#303133" } },
            [_vm._v("【")]
          ),
          _vm._v("\n        以报价表为准 "),
          _c(
            "span",
            { staticStyle: { "font-weight": "bold", color: "#303133" } },
            [_vm._v("】")]
          )
        ]),
        _vm._v(" "),
        _c("p", { staticStyle: { "font-weight": "bold", color: "#303133" } }, [
          _vm._v(
            "\n        未经亦邦物流书面许可或亦邦物流给予员工的书面授权文件，任何员工给予您的价格优惠均不对亦邦物流发生法律效力。亦邦物流有权按照本条款与条件载明的收费标准向您收取费用，您知悉并无异议。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        收件人可在货物派送前被要求支付在收件人所在国家或地区亦邦物流通知中载明的应付关税和其他费用，其中包括亦邦物流代表收件人支付的任何关税费用。如果收件人未付款的，则发件人应向亦邦物流支付或补偿亦邦物流因其提供服务或代表发件人或收件人产生的所有关税和其他费用。\n      "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "paragraph" }, [
      _c("div", [_vm._v("六、亦邦物流的责任")]),
      _vm._v(" "),
      _c("div", { staticStyle: { "font-weight": "bold", color: "#303133" } }, [
        _c("p", [
          _vm._v(
            "\n        6.1无论《蒙特利尔公约》或《华沙公约》是否适用，亦邦物流对任何一票通过空运或海运方式运输（包括货物运输中的陆路运输或中途停靠）的货物的责任（包括但不限于货物丢失、毁损等）应按以下金额低者为限，且运费不予赔偿：（i）当前市场价值或申报价值，但最高不超过【】元人民币，若出现进口申报货值与出口申报货值不一致的情形，则以二者孰低为准；或（ii）亦邦物流收取的运费的二倍。上述责任限制也适用于其他运输方式，除非货物仅通过陆运方式运输，陆运方式的责任限制如下：\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        无论《国际公路货物运输公约》是否适用，亦邦物流对以陆运方式运输的国际货物的责任应按以下金额低者为限：（i）当前市场价值或申报价值，但最高不超过【】元人民币；或（ii）亦邦物流收取的运费的二倍。上述责任限制也适用于国内陆路运输，如果在可适用的国内运输法律中没有规定强制性的或更低的责任限额。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        亦邦物流在任何一票仅在中国境内运输的货物运输中所承担的全部责任都不超过【】元人民币/公斤。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        若发件人认为上述责任限额不足以补偿其损失，则应对货物的价值作出特别声明并按本条款与条件第九条的规定要求保险或自行投保或保价。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        对每票货物造成的损害，亦邦物流所承担的责任仅限于直接的损失，且不超过本条所规定的每公斤的限额。亦邦物流不承担任何其它损失或损害（包括但不限于利润、收入、利息及未来业务的损失），无论这些其它损失和损害是特殊的或是间接的，无论亦邦物流是否知晓存在这些损失或损害的风险。\n      "
          )
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticStyle: { "font-weight": "normal", color: "#303133" } },
          [
            _vm._v(
              "\n        6.2亦邦物流将按照其正常运送标准尽合理努力派送货物，但这些标准并不具有约束力，也不构成协议的组成部分。亦邦物流不对运输延误而导致的任何损失或损害承担责任。但针对某些货物，发件人有权根据本条款与条件第7条退款保证索赔有限的延误赔偿。\n      "
            )
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "paragraph" }, [
      _c("div", [_vm._v("七、退款保证")]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v(
            "\n        7.1当亦邦物流未能在承诺的递送时间内将您的货物送达收件人时，亦邦物流将根据您的请求，在符合下列条件的前提下对您进行赔偿。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("7.2亦邦物流退款保证（以下简称“退款保证”）适用于如下条件：")
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("A.退款保证仅适用于以下服务：阿联酋海派限时达")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        （每一项称为“服务”），并且提供的服务仅限于亦邦物流在浙江义乌及广东东莞仓库发出的普通货物。为免疑义，普通货物指非品牌，非液体粉末纯电，非阿联酋禁运产品（电子烟、食品、药品、保健品，成人用品、赌博游戏机、古兰经相关产品、军火武器、易燃易爆品等），具体以亦邦物流认定的为准。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        B.若出现货物延误的情况，您必须于延迟之日起三个日历日内，以书面形式或致电亦邦物流提出索赔，并提供亦邦物流账号（如有）、运单号、发件日期，以及完整的收件人信息，否则亦邦物流将不再承担任何责任。接到通知后三十个日历日内，亦邦物流将作出下列其中一项处理：\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        （1）从入仓后第二天后开始计算，35个自然日未送达亚马逊仓从第36个自然日起按照15RMB/CBM/天向您赔偿，赔付上限封顶10天且不超过您支付的运费总额。为免疑义，国外节假日、海关查验时间及亚马逊仓爆仓取消约仓的不计算入送达时限内。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        （2）向您提供相关资料，说明根据适用的条件和限制，所申请索赔的货物不符合退款保证条件，不能赔偿；\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("（3）提供相关资料，证明货物已准时派送。")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        C.您不得允许任何第三方代表其提出退款申请或将索赔权转让至任何第三方。一旦亦邦物流将赔偿费用退还至您，则亦邦物流对于该货物延误所带来的责任将完全免除。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        D.本退款保证条款不适用于在本条款与条件中规定的任何超出亦邦物流控制范围的原因造成的派送延迟或失败，这些不可抗拒因素包括海关延误、不正确或不完整的货物信息、派送指示或信息（包括收件人地址中的邮箱号码错误、收件人电话号码缺失或错误）、收件人要求延误、货物转移或者特别清关服务、收件人无法签收、拒绝收件或拒绝支付派送时要求其支付的关税或税金。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        E.本条款与条件所列明的其它条款均适用于本退款保证。本退款保证可由亦邦物流随时修改或解除。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        F.如果您对某票货物的派送时间有特别严格的要求，而且该货物的丢失或派送延迟可能导致间接损失，您必须通过其保险经纪人或保险公司代理人对其风险进行投保，亦邦物流并不承担该赔偿责任。亦邦物流不提供、亦不安排此项保险。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("7.3本退款保证不适用于：")]),
        _vm._v(" "),
        _c("p", { staticStyle: { "text-indent": "3em" } }, [
          _vm._v("\n        （1）需要使用温控包装的临床试验用品；和/或\n      ")
        ]),
        _vm._v(" "),
        _c("p", { staticStyle: { "text-indent": "3em" } }, [
          _vm._v(
            "\n        （2）货物所附带的可选服务收取的额外费用，譬如包装；和/或\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticStyle: { "text-indent": "3em" } }, [
          _vm._v("（3）临时出口或进口；和/或")
        ]),
        _vm._v(" "),
        _c("p", { staticStyle: { "text-indent": "3em" } }, [
          _vm._v("（4）需正式报关的高价值物品；和/或")
        ]),
        _vm._v(" "),
        _c("p", { staticStyle: { "text-indent": "3em" } }, [
          _vm._v("（5）货件超过规定重量或尺寸限制；和/或")
        ]),
        _vm._v(" "),
        _c("p", { staticStyle: { "text-indent": "3em" } }, [
          _vm._v("（6）包含可运输危险品的货物；")
        ]),
        _vm._v(" "),
        _c("p", { staticStyle: { "text-indent": "3em" } }, [
          _vm._v(
            "\n        （7）本条款与条件第二条所规定的不能承运之货物。\n      "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "paragraph" }, [
      _c("div", [_vm._v("八、索赔时限")]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v(
            "\n        除本条款与条件另有规定外，任何索赔必须在您对亦邦物流提供的货物运输服务产生争议后48小时内以书面方式向亦邦物流提出，否则亦邦物流将不再承担任何责任。每票货物只能提出一次索赔，且这种赔偿将作为对有关损失及损害的全部和最终的解决方案。\n      "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "paragraph" }, [
      _c("div", [_vm._v("九、货物保险和保价")]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v(
            "\n        如发件人在亦邦物流提供服务时，同时选择对货物进行保险/保价的，在发件人支付所需保险费/保价费后，亦邦物流可以为发件人按照货物的价值就货物的丢失或货物自身的毁损投保。货物保险不包括间接损失或损害，也不包括因运输延误而导致的损失或损害。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        请您注意，亦邦物流提供的保价服务本意是提供一种解决方案，以便使您有机会就一般性赔偿责任无法覆盖的损失获得赔偿，并非获得超额补偿的方式，因此请您本着诚实原则如实申报货物的价值，填写保价金额。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        亦邦物流提供的保价服务，系按照保价金额的一定比例收取保价费，详细见报价表。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        您理解，受限于货物的性质，亦邦物流无法对所有的货物一概提供保价增值服务，具体可提供保价增值服务的货物品类以亦邦物流确认的为准。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        为节约时间，亦邦物流对货物价值无法在收件时逐一验证价值，故采取“理赔时审查”的方式，包括：\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        （1）您应在亦邦物流为您提供服务时按照货物的实际价值诚信保价（包含如实申报或填写保价金额），若保价金额高于货物实际价值的，亦邦物流赔付最高不超过货物的实际价值。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        （2）您应在理赔时提供货物的真实有效价值证明（如发票，合同、付款凭证组合）并按亦邦物流要求提供相关资料（如包含运单号的外包装、内包装、填充物和货物损坏情况的图片，前述全部关键要素在同一张图内的图片）以及主动告知货物损失情况，特殊情况亦邦物流会安排工作人员上门确认核实。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        （3）如您寄递一票多件，货物相同，发生部分货物丢失或损坏，根据保价金额除以物品总数量计算单个货物的保价金额；货物不同，发生部分货物丢失或损坏，根据各货物的保价金额按比例计算单个货物的保价金额，如您认为该赔偿标准不足以弥补您的损失，亦邦物流建议对贵重物品单独寄递并选择保价服务。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        （4）如您无法证明货物的实际价值或双方对货物实际价值有争议的，亦邦物流将结合市场价值或/和第三方评估机构出具的损失价值，基于本协议的约定对您进行赔偿，但本协议另有约定的除外。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        若您购买了亦邦物流的保价服务，亦邦物流将按照以下相应标准进行赔偿：\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        若货物出现全部丢失或损坏（含无法维修）的情况，将根据实际损失金额进行全额赔偿，最高不超过保价金额；货物出现部分损坏的情况，如货物可维修，则赔付维修费用，如货物无需维修，按照保价金额乘以损坏程度进行赔偿，最高不超过保价金额。\n      "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "paragraph" }, [
      _c("div", [_vm._v("十、清关")]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v(
            "\n        在亦邦物流为您提供货物运输服务时，若同时负责为您代理货物清关（包括进口清关及出口清关），则在亦邦物流依照海关规定办理海关申报、查验、征税等手续时，若海关要求亦邦物流提供与货物相关文件、资料时，您同意按照亦邦物流要求及时履行配合义务，因您逾期或拒不履行配合义务的，由此产生的损失由您自行承担，包括但不限于扣货、罚没及罚金等。同时，若您的前述行为同时给亦邦物流造成其他损失的，亦邦物流有权向您追偿。您清楚的知悉并同意亦邦物流仅作为代理人代您办理清关手续，清关过程中最终的法律责任由您独自承担。\n      "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "paragraph" }, [
      _c("div", [_vm._v("十一、货值")]),
      _vm._v(" "),
      _c("div", [
        _c("p", { staticStyle: {} }, [
          _vm._v(
            "\n        在亦邦物流为您提供货物运输服务时，除非您另行以书面方式通知亦邦物流，\n        "
          ),
          _c(
            "span",
            { staticStyle: { "font-weight": "bold", color: "#303133" } },
            [
              _vm._v(
                "\n          亦邦物流将自行决定采取合理方式向海关申报货值。在此过程中，若出现您申报的货值低于实际货值的，由此产生的税费补缴等法律责任均由您自行承担。"
              )
            ]
          ),
          _vm._v(
            "\n        因此给亦邦物流造成损失的，亦邦物流有权向您追偿。\n      "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "paragraph" }, [
      _c("div", [_vm._v("十二、对账")]),
      _vm._v(" "),
      _c("div", [
        _c("p", { staticStyle: {} }, [
          _vm._v("\n        在亦邦物流为您提供货物运输服务时，\n        "),
          _c(
            "span",
            { staticStyle: { "font-weight": "bold", color: "#303133" } },
            [
              _vm._v(
                "您应在收到亦邦物流向您发送的账单后48小时内予以确认和异常反馈，如您未反馈或未及时反馈的视为您完全认可账单金额及明细。"
              )
            ]
          ),
          _vm._v(
            "\n        您应按照约定完成付款，逾期支付的，每逾期一日按照应支付金额的万分之五向亦邦物流支付违约金。为免疑义，亦邦物流向您发送账单的方式包括但不限于QQ、电子邮件、微信、微信群、短信、EMS、传真等方式。\n      "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "paragraph" }, [
      _c("div", [_vm._v("十三、处置货物")]),
      _vm._v(" "),
      _c("div", [
        _c("p", { staticStyle: {} }, [
          _vm._v("\n        在亦邦物流为您提供货物运输服务时，\n        "),
          _c(
            "span",
            { staticStyle: { "font-weight": "bold", color: "#303133" } },
            [
              _vm._v(
                "若您违反本条款及条件中载明的义务，且在亦邦物流给予\n          的宽限期内仍未整改或消除违约行为的，亦邦物流有权暂停向您提供服务，同时有权要求您自行或委托第三方在亦邦物流要求时间内自费取回货物（但前提是您已经按照约定履行付款义务或消除违约行为），逾期未取回的视为遗弃，亦邦物流有权经行处理该等货物，"
              )
            ]
          ),
          _vm._v(
            "\n        由此产生的处置费用由您承担，本条款及条件中的其他条款另有约定的从其约定。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        若您需要亦邦物流为你提供仓储服务，则亦邦物流在向您提供仓储服务时，您需要支付相应的仓储服务费，您应在收到亦邦物流向您发送的账单后48小时内予以确认和异常反馈，如您未确认或未及时反馈的视为您完全认可账单金额及明细。您应按照约定完成付款，逾期支付的，每逾期一日按照应支付金额的万分之五向亦邦物流支付违约金，且在此期间暂停对您提供服务（包括但不限于暂停上架及/或下架货物）。为免疑义，亦邦物流向您发送账单的方式包括但不限于QQ、电子邮件、微信、微信群、短信、EMS、传真等方式。若您逾期支付费用的亦邦物流有权要求您自行或委托第三方在亦邦物流要求时间内自费取回货物（但前提是您已经按照约定履行付款义务或消除违约行为），逾期未取回的视为遗弃，亦邦物流有权经行处理该等货物。\n      "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "paragraph" }, [
      _c("div", [_vm._v("十四、不可抗拒因素")]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v(
            "\n        对于超出亦邦物流控制范围的原因而导致的损失或损害，亦邦物流不承担责任。这些原因包括但不限于：对于电子音像图片、数据或纪录的电磁性损坏或删除；货物固有的缺陷或特性(无论亦邦物流是否知晓)；非亦邦物流雇员或与亦邦物流没有合同关系的人员的作为或不作为，如发件人、收件人、第三人、海关或其他政府部门；第三方网络攻击或其他信息安全相关威胁；不可抗力，如地震、龙卷风、风暴、洪水、大雾、战争、空难、禁运、暴乱、传染性疾病、流行病、民间骚乱或劳资事件。\n      "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "paragraph" }, [
      _c("div", [_vm._v("十五、发件人的陈述、保证和赔偿责任")]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v(
            "\n        如发件人违反以下保证和陈述，发件人应赔偿因此而给亦邦物流及其董事、高级职员、雇员和代理造成的所有及任何的责任、损失和损害：\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("（1）根据本条款与条件第二条，货物是可承运的；")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        （2）货物系由可信赖的人员在安全的前提下准备，并确保货物在准备、仓储或运输过程中亦邦物流免受他人不当干扰；\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        （3）发件人已遵守适用的出口管制、制裁、海关法律法规或其他适用的与货物进口、出口、过境或转移相关的监管要求和限制；\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        （4）发件人已向亦邦物流声明货物中包含的任何须经政府授权的受控两用物项或军品；\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        （5）发件人已按照适用法律的要求或亦邦物流的要求提供了所有信息、许可证、执照或其他政府授权书和文件，且发件人或其代表提供的所有信息、许可证、执照或其他政府授权书和文件（包括货物的价值和描述以及发件人和收件人信息）均真实、完整和准确；\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        （6）发件人保证其委托亦邦物流运输的货物或其任何部分均不会侵犯任何第三方的专利、商标、著作权或任何其他权益。否则，您将承担对第三方的侵权责任，并承担由此对亦邦物流造成的一切损失和费用(包括但不限于律师费、诉讼费、保全费等)；\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        （7）您委托亦邦物流出运的货物到达目的港后，若在十五天内发生因收货人不提货、无法联系收货人、收货人下落不明等任何原因导致发生无人提货的或者发生货物被海关扣留等无法及时清关的，亦邦物流接到船公司或代理通知后，以合同约定的电子邮件/QQ/书面的方式通知您，若您在三日内未书面回复亦邦物流的，亦邦物流有权采取包括但不限于弃货处理、退运等合理的止损措施，由此所产生的费用以亦邦物流与第三方包括但不限于其国外代理及其订舱船公司、订舱代理等其他方确认的金额为准(包括但不限于滞箱费、堆存费、滞期费、运费、操作费、拍卖费、公证费、认证费、诉讼费、律师费、鉴定费等)，均由您承担，该费用您承诺在收到亦邦物流的书面通知后三日内支付给亦邦物流或者指定收款人。您委托的货物到达目的港收货人逾期未提货所产生的额外费用以及运费到付费用，由收货人承担，收货人未及时支付的，您对上述费用承担连带责任，亦邦物流有权向您追偿，您不得拒付。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        （8）在向亦邦物流提供个人信息时，发件人已遵守其处理和共享该等个人信息的法律义务，包括通知受影响的个人，因运输、清关和派送货物的需要，须提供个人信息（包括收件人的电子邮件地址和移动电话号码）。\n      "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "paragraph" }, [
      _c("div", [_vm._v("十六、路线")]),
      _vm._v(" "),
      _c("div", [
        _c("p", [_vm._v("发件人接受所有路线和绕航，包括可能的运输中转站。")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "paragraph" }, [
      _c("div", [_vm._v("十七、法律适用和争议解决")]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v(
            "\n        除与所适用法律冲突，与本条款与条件有关的一切争议将受到亦邦物流住所地法院的非排他管辖，并适用亦邦物流住所地所在国法律，发件人不可撤销地接受该管辖。\n      "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "paragraph" }, [
      _c("div", [_vm._v("十八、可分割性")]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v(
            "\n        亦邦物流为您提供服务过程中，如另行与您签订了书面合同，则对于本条款与条件与书面合同约定不一致的，以书面合同约定为准。书面合同未作约定的，以本条款与条件约定为准。\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        本条款与条件任何部分的无效或不可执行，不影响其他条款的效力和执行。本条款与条件以中文和英文两种语言并列制作，您清楚知悉、了解并确认并理解了本条款与条件载明的全部内容，并以中文文本为准。\n      "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33b7aa4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33b7aa4a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./common/serviceAgreement.vue
// module id = null
// module chunks = 